export const getAvatarInitials = (name: string, fallback = "П"): string => {
  const selectedName = name.includes("|")
    ? (name.split("|")[1] || "").trim()
    : name;
  const words = selectedName
    .replace(/\(.*?\)/g, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return fallback;
  if (words.length === 1) return words[0][0].toUpperCase();
  if (words.length >= 3 && words[1].toLowerCase() === "и") {
    return `${words[0][0]}${words[2][0]}`.toUpperCase();
  }
  return `${words[0][0]}${words[1][0]}`.toUpperCase();
};
